import { Col, Container, Row } from "react-bootstrap";
import SocialLinks from "../Card/SocialLinks";
import { Link } from "react-router-dom";

export default function Footer(){

    return(
        <footer className="app-footer">
          <Container>
            <Row className="footer-top">
                <Col xs={12} sm={5} md={4} lg={3} className="footer-brand">
                    <img id="logo" src={require('../../assets/Fatteh-Logo.webp')} alt='fatte logo' />
                </Col>
                <Col xs={12}sm={7} md={8} lg={9} className="footer-middle">
                    <p>Fatteh is a bold new magazine that aims to inform, inspire and empower LGBTQ+ Ethiopians and the global Habesha diaspora.</p>
                    <p>We cover the issues that matter to this unique community, allowing its members to see themselves fully reflected and authentically represented in a range of Amharic and English language content.</p>
                </Col>
            </Row>
            <Row >
                <Row className="footer-brand-wrapper">
                    <Col xs={3} className="footer-brand">
                        <h1>Fatteh!</h1>
                        <h5>Ignite change</h5>
                    </Col>
                    
                    <Col xs={3}>
                        <SocialLinks />
                    </Col>
                    <Col xs={12} md={6} className="footer-middle-bottom">
                        <p>Please read our <Link className="link-dark-bacground" to={'/terms'}>Terms of use and Privacy policy</Link></p>
                        <p>© {new Date().getFullYear()} Fatteh Magazine - All Rights Reserved.</p>
                    </Col>
                </Row>
            </Row>
          </Container>
        </footer>
    )
}